import { Card, Typography } from "antd";
import { ProgressBar } from "./ProgressBar";
import styles from "./RankingTable.module.css";

const { Title, Text } = Typography;

// Интерфейс для данных рейтинга
export interface RankingData {
  metric: string;
  score: number;
  maxScore: number;
  color: string;
}

// Интерфейс для пропсов таблицы
export interface RankingTableProps {
  title: string;
  data: RankingData[];
  width?: string | number;
  showHeader?: boolean;
}

// Стили для таблицы

// Переиспользуемый компонент таблицы рейтинга
export const RankingTable = ({
  title,
  data,
  width = "100%",
  showHeader = true,
}: RankingTableProps) => {

  return (
    <Card className={styles.container} bordered={false} style={{ width }}>
      {showHeader && (
        <div className={styles.header}>
          <Title level={3} className={styles.title}>
            {title}
          </Title>
        </div>
      )}

      <div className={styles.table}>
        <div className={styles.tableRow}>
          {/* Колонка с названиями метрик */}
          <div className={styles.tableColumn}>
            {data.map((item, index) => (
              <div
                key={item.metric}
                className={`${styles.tableCell} ${
                  index === data.length - 1 ? styles.tableCellLast : ""
                }`}
              >
                <Text className={styles.metricName}>{item.metric}</Text>
              </div>
            ))}
          </div>

          {/* Колонка с прогресс-барами */}
          <div className={styles.tableColumn}>
            {data.map((item, index) => (
              <div
                key={item.metric}
                className={`${styles.tableCell} ${
                  index === data.length - 1 ? styles.tableCellLast : ""
                }`}
              >
                <ProgressBar
                  value={item.score}
                  max={item.maxScore}
                  color={item.color}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};
